
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/exchange",
      function () {
        return require("private-next-pages/account/exchange/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/exchange"])
      });
    }
  